import { connect } from 'react-redux'
import { sagaActions } from 'store/sagas'
import UserSettingsGeneral from './UserSettingsGeneral'
import { currentUserSettingsSelector } from 'selectors/currentUserSettings'

export default connect(
  (state, props) => {
    return {
      config: state.kanbo.config,
      settings: currentUserSettingsSelector(state, props)
    }
  },
  {
    requestChangeUserSettings: sagaActions.requestChangeUserSettings
  }
)(UserSettingsGeneral)
